// extracted by mini-css-extract-plugin
module.exports = {"scatter_tooltip":"kshaperesult_scatter_tooltip_35A1K","sbd_table":"kshaperesult_sbd_table_1gqQ2"};